'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const get = require('lodash.get');
const { Provider } = require('react-redux');
const { combineReducers, createStore, applyMiddleware } = require('redux');
const { reducers } = require('dibs-contact-modal');
const { track } = require('../../../global/utils/social/chat');
const MakeOfferRenderer = require('../components/MakeOfferRenderer');
const authProcess = require('./authHelper.es');
const {constants: authConstants} = require('../../../auth/authModalLoader').default;
const modalContainer = document.createElement('div');

module.exports = options => {
    const {
        item,
        linkLocation,
        currency,
        currentStep,
        preloadedState = {}
    } = options;

    let itemId;
    let sellerId;

    // If backbone model passed
    if (item && item.get) {
        itemId = item.get('id');
        sellerId = item.get('seller.id');
    } else {
        itemId = get(item, 'id');
        sellerId = get(item, 'seller.id');
    }

    const modalProps = {
        itemId,
        sellerId,
        chatTracking: track,
        pageCurrency: currency,
        linkLocation,
        startAuth: (authProps) => authProcess({...authProps, flow: authProps.makeOffer && authConstants.CONTACT_DEALER_FORM_FLOW}),
        currentStep
    };

    const store = createStore(
        combineReducers(reducers),
        preloadedState,
        applyMiddleware(require('redux-thunk').default)
    );

    ReactDOM.render(
        <Provider store={ store }>
            <MakeOfferRenderer modalProps={modalProps} />
        </Provider>,
        modalContainer
    );
};



// WEBPACK FOOTER //
// ./assets/js/contact/offer/helpers/MakeOfferLauncher.jsx